<template>
    <div class="col-md-3 pull-left">
        <div class="form-group">
            <label>Restaurant</label>
            <multiselect
                v-model="selectedRestaurant"
                @input=" (value) => $emit('restaurant', value)"
                :options="restaurants"
                deselect-label="Can't remove this value"
                :allow-empty="false"
                placeholder="Select Restaurant"
                label="name"
                track-by="name"
            />
        </div>
    </div>

</template>

<script>
import Multiselect from "vue-multiselect";
import {getAllRestaurant} from "@/api/restaurants";
import User from "@/services/User";

export default{
    name: "AdminFiltersComponent",
    components: {Multiselect},
    data() {
        return {
            restaurants: [],
            selectedRestaurant: "",
        }
    },
    computed: {
        userRole() {
            return this.$store.getters.user.userRolesById[0].role;
        },
    },
    created: async function () {


        // if (this.userRole === 'ROLE_ADMIN') {
        //     await this.fetchRestaurant();
        // }

      User.fetchUserRoles().then(async role => {
        this.loggedInRole = role;
        switch (role) {
          case 'ROLE_ADMIN': {
            await this.fetchRestaurant();
            break;
          }
          case 'ROLE_USER': {
            this.restaurants.push({
              id: this.$store.state.user.restaurant.id,
              name: this.$store.state.user.restaurant.name
            });
            break;
          }

        }
      });

    },
    methods: {
        async fetchRestaurant() {
            let restaurantResp = await getAllRestaurant()
                .catch(ex => {
                    this.showErrorMessage(ex)
                });
            this.restaurants = restaurantResp.data;
        },
    }
}
</script>

<style scoped>
.search_btn{
    margin-top: 25px;
    margin-right: 10px
}
</style>